import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { SectionCard, WhiteCard } from 'src/components';

import './agreement.scss';

export const Agreement = () => {
  const { t } = useTranslation('agreement');

  // eslint-disable-next-line jsx-a11y/heading-has-content
  const components = { h4: <h4 />, h5: <h5 />, div: <div style={{ display: 'flex' }} /> };

  return (
    <div className="agreement">
      <SectionCard title={t('title')}>
        <WhiteCard>
          <div className="agreement__translation">
            <Trans i18nKey="agreement:1" components={components} />
          </div>
          <div className="agreement__translation">
            <Trans i18nKey="agreement:2" components={components} />
            <Trans i18nKey="agreement:2.1" components={components} />
            <Trans i18nKey="agreement:2.2" components={components} />
            <Trans i18nKey="agreement:2.3" components={components} />
            <Trans i18nKey="agreement:2.4" components={components} />
          </div>
          <div className="agreement__translation">
            <Trans i18nKey="agreement:3" components={components} />
          </div>
          <div className="agreement__translation">
            <Trans i18nKey="agreement:4" components={components} />
          </div>
          <div className="agreement__translation">
            <Trans i18nKey="agreement:5" components={components} />
            <Trans i18nKey="agreement:5.1" components={components} />
            <Trans i18nKey="agreement:5.2" components={components} />
            <Trans i18nKey="agreement:5.3" components={components} />
            <Trans i18nKey="agreement:5.4" components={components} />
            <Trans i18nKey="agreement:5.5" components={components} />
            <Trans i18nKey="agreement:5.6" components={components} />
            <Trans i18nKey="agreement:5.7" components={components} />
            <Trans i18nKey="agreement:5.8" components={components} />
            <Trans i18nKey="agreement:5.9" components={components} />
            <Trans i18nKey="agreement:5.10" components={components} />
            <Trans i18nKey="agreement:5.11" components={components} />
            <Trans i18nKey="agreement:5.12" components={components} />
            <Trans i18nKey="agreement:5.13" components={components} />
            <Trans i18nKey="agreement:5.14" components={components} />
            <Trans i18nKey="agreement:5.15" components={components} />
            <Trans i18nKey="agreement:5.16" components={components} />
            <Trans i18nKey="agreement:5.17" components={components} />
            <Trans i18nKey="agreement:5.18" components={components} />
          </div>
          <div className="agreement__translation">
            <Trans i18nKey="agreement:6" components={components} />
          </div>
          <div className="agreement__translation">
            <Trans i18nKey="agreement:7" components={components} />
          </div>
          <div className="agreement__translation">
            <Trans i18nKey="agreement:8" components={components} />
          </div>
          <div className="agreement__translation">
            <Trans i18nKey="agreement:9" components={components} />
          </div>
          <div className="agreement__translation">
            <Trans i18nKey="agreement:10" components={components} />
          </div>
          <div className="agreement__translation">
            <Trans i18nKey="agreement:11" components={components} />
            <Trans i18nKey="agreement:11.1" components={components} />
            <Trans i18nKey="agreement:11.2" components={components} />
            <Trans i18nKey="agreement:11.3" components={components} />
            <Trans i18nKey="agreement:11.4" components={components} />
            <Trans i18nKey="agreement:11.5" components={components} />
          </div>
          <div className="agreement__translation">
            <Trans i18nKey="agreement:12" components={components} />
          </div>
          <div className="agreement__translation">
            <Trans i18nKey="agreement:13" components={components} />
            <Trans i18nKey="agreement:13.1" components={components} />
            <Trans i18nKey="agreement:13.2" components={components} />
            <Trans i18nKey="agreement:13.3" components={components} />
            <Trans i18nKey="agreement:13.4" components={components} />
            <Trans i18nKey="agreement:13.5" components={components} />
            <Trans i18nKey="agreement:13.6" components={components} />
            <Trans i18nKey="agreement:13.7" components={components} />
            <Trans i18nKey="agreement:13.8" components={components} />
          </div>
        </WhiteCard>
      </SectionCard>
    </div>
  );
};
